import {useQuery} from '@aboutyou/data-fetcher';
// @ts-ignore
import ExpressCheckoutSDK from 'express-checkout-sdk/dist/express-checkout.module.js';
import {SDKInstance} from './types';

const EXPRESS_SDK_INSTANCE_QUERY_KEY = 'EXPRESS_SDK_INSTANCE_QUERY_KEY';

export const useExpressCheckout = () => {
  const sdk = () => new ExpressCheckoutSDK();

  return useQuery<SDKInstance>(EXPRESS_SDK_INSTANCE_QUERY_KEY, sdk);
};
